// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2L8kN","title":"card_title__1Ta0e","inActive":"card_inActive__MBNAI"};